import React, { Component } from "react";
import OtpLogin from "components/UnauthorizedComponents/OtpLogin";
import Api from "Api/Api";
import Utils from "Utils";
import { Popup } from "devextreme-react";

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      showPopup: false,
      showEmailForm: true,
    };
    this.checkEmail = (e) => {
      e.preventDefault();
      Api.changePswdRequest(e.target.request_email.value).then((response) => {
        if (response.status === 200) {
          this.setState({ showEmailForm: false });
          Utils.notify(
            "An email is sent out to you containg the token for changing the value"
          );
        } else {
          Utils.notify("Something wrong happened", "warning");
        }
      });
    };
    this.changeToTokenForm = () => {
      this.setState({ showEmailForm: false });
    };
    this.changePswd = (e) => {
      e.preventDefault();
      if (e.target.pswd.value === e.target.cnf_pswd.value) {
        Api.changePswd(e.target.token.value, e.target.pswd.value).then(
          (response) => {
            if (response.status === 200) {
              this.togglePopup();
              this.setState({ showEmailForm: true });
            }
          }
        );
      } else {
        Utils.notify("Password and confirm password doesn't match", "error");
      }
    };
    this.showHidePassword = () => {
      this.setState({ showPassword: !this.state.showPassword });
    };
    this.togglePopup = () => {
      this.setState({ showPopup: !this.state.showPopup });
    };
  }

  render() {
    return (
      <>
        <OtpLogin />
        <Popup
          visible={this.state.showPopup}
          title={"Forgot Password?"}
          onHiding={this.togglePopup}
          height={"auto"}
          width={"auto"}
          showCloseButton={true}
        >
          <div>
            {this.state.showEmailForm ? (
              <form onSubmit={this.checkEmail}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label className="bmd-label-floating">
                        Enter your registered email
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        name="request_email"
                      />
                    </div>
                  </div>
                </div>
                <p
                  onClick={this.changeToTokenForm}
                  className="pointer"
                  style={{ color: "#a746b8" }}
                >
                  Got the token? Enter here for verification.
                </p>
                <button type="submit" className="btn btn-primary pull-right">
                  Next
                </button>
              </form>
            ) : (
              <form onSubmit={this.changePswd}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label className="bmd-label-floating">
                        Token from email
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="token"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <div className="form-group">
                      <label className="bmd-label-floating">New password</label>
                      <input
                        type={`${
                          this.state.showPassword ? "text" : "password"
                        }`}
                        className="form-control"
                        name="pswd"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <div className="form-group">
                      <label className="bmd-label-floating">
                        Confirm password
                      </label>
                      <input
                        type={`${
                          this.state.showPassword ? "text" : "password"
                        }`}
                        className="form-control"
                        name="cnf_pswd"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-2 showPass">
                    <i
                      className="material-icons showPassword"
                      onClick={this.showHidePassword}
                      title={this.state.showPassword ? "Hide" : "Show"}
                    >
                      {this.state.showPassword
                        ? "visibility_off"
                        : "remove_red_eye"}
                    </i>
                  </div>
                </div>
                <button type="submit" className="btn btn-primary pull-right">
                  Change password
                </button>
              </form>
            )}
          </div>
        </Popup>
      </>
    );
  }
}
